import { apiGetClientInit } from '@/api/public'
import type {
  micEmojiInterface,
  emojiJsonInterface,
  micEmojiAnimationInterface
} from '~/types/apiType/publicTyps'
/** 麦位表情 */
export const useMicEmojiStore = defineStore({
  id: 'micEmoji',
  state: () => ({
    /** 表情动画是否播放中(自己) */
    isPlaying: false,
    /** 上次获取礼物接口的时间，超过24小时就获取一次 */
    lastTime: 0,
    /** 麦位表情列表 */
    micEmojiList: [] as micEmojiInterface[],
    /** 麦位表情要播动画，没有队列，就放这处理了 */
    micEmojiAnimationMap: {} as Record<number, micEmojiAnimationInterface>
  }),
  actions: {
    /**
     * 发送表情通知im
     * @param faceId 表情id
     */
    sendMicEmoji(faceId: number) {
      if (this.isPlaying) return // 播放中就不再发送
      const socketStore = useSocketStore()
      const roomStore = useRoomStore()
      const userStore = useUserStore()
      const face = this.micEmojiList.find((item) => item.id === faceId) || null

      const custom = {
        first: 9,
        second: 91,
        data: {
          data: [
            {
              faceId,
              nick: userStore.userInfo.nick,
              uid: userStore.userInfo.uid
            }
          ],
          experLevel: userStore.levelExperienceInfo.levelSeq,
          uid: userStore.userInfo.uid
        }
      }
      // 特殊表情添加字段
      if (face && face.resultCount > 0) {
        let index = 0
        const resultIndexes: number[] = []
        while (index < face.resultCount) {
          const randomNumber = Math.floor(
            Math.random() * (face.resultEndPos - face.resultStartPos + 1) +
              face.resultStartPos
          )
          resultIndexes.push(randomNumber)
          index++
        }
        custom.data.data[0]['resultIndexes'] = resultIndexes
      }
      const req_data = {
        custom: JSON.stringify(custom),
        member: JSON.stringify(roomStore.userMemberInfo),
        room_id: String(roomStore.roomInfo.roomId)
      }
      socketStore.sendMessage(req_data)
    },
    /**
     * 播放完成时移除表情信息
     */
    removeUserEmoji(uid: number) {
      uid && delete this.micEmojiAnimationMap[uid]
    },
    /** 监听发送的麦位表情*/
    onUserSendMicEmoji(data) {
      const face = this.micEmojiList.find(
        (item) => item.id === data.data?.[0]?.faceId
      )
      if (face) {
        const resultInfo = data.data?.[0] || {}
        this.micEmojiAnimationMap[data.uid] = {
          ...face,
          resultInfo
        }

        const roomStore = useRoomStore()
        if (face.resultCount > 0) {
          setTimeout(() => {
            const resultIndexes = resultInfo?.resultIndexes || []
            const faceUrls = resultIndexes.map((num) =>
              this.getMicEmojiUrl({ ...face, pos: num })
            )
            // 表情结果显示公屏
            roomStore.updateChatList('put', {
              id: data.timestamp,
              type: constant.ROOM_CHAT_TYPE.EMOJI_RESULT,
              content: '',
              nick: resultInfo?.nick,

              faceUrls
            })
          }, 3000)
        }
      }
    },
    /**
     * 初始化表情信息
     */
    async initMicEmojiInfo() {
      const nowTime = new Date().getTime() // 现在的时间
      // 没数据，或者和上次获取的时间超过24小时就获取 3600000
      if (
        this.micEmojiList.length === 0 ||
        this.lastTime === 0 ||
        nowTime >= this.lastTime + 3600000 * 24
      ) {
        const { data, code } = await apiGetClientInit()

        if (code === 200) {
          try {
            const jsonString = cryptojs.decryptDES(
              (data.faceJson.json as string).replace(/[\r\n\s]/g, ''),
              cryptojs.keyOfKey
            )
            this.micEmojiList = (
              JSON.parse(jsonString) as emojiJsonInterface
            ).faces
            this.lastTime = nowTime // 赋值刷新接口的时间
            console.log('表情栏解析成功', JSON.parse(jsonString))
          } catch (error) {
            console.error('表情栏解析错误', error)
          }
        }
      }
    },
    /** 获取表情图片
     * @param {string} pinyin 文件名
     * @param {number} id 文件id
     * @param {number} pos 帧数
     */
    getMicEmojiUrl(params: {
      pinyin: string
      id: number
      pos: number
      [key: string]: any
    }): string {
      /**
       * 表情图片cdn基础链接 (为自己上传到七牛的图片)
       */
      const FACE_URL = ' https://pic.leeski.net/room/face/face7/'
      const { pinyin, id, pos } = params
      return common.handlePicUrl(
        `${FACE_URL}${pinyin}_${id}/${pinyin}_${id}_${pos}.png`
      )
    },
    /**
     * 设置状态(自己)
     */
    setPlayStatus(value: boolean) {
      this.isPlaying = value
    },
    resetData() {
      this.micEmojiAnimationMap = {}
    }
  },
  persist: {
    key: 'micEmojiStore',
    paths: ['micEmojiList', 'lastTime']
  }
})
